export const templatePageSeoProps = (templateName, seoProps) => {
	let {seoTitle, seoDescription} = seoProps

	seoTitle = seoTitle ? `${seoTitle} ${templateName}` : templateName
	seoDescription = seoDescription ? `${seoDescription} ${templateName}` : templateName

	return {seoTitle, seoDescription}
}
